export default __webpack_public_path__ + "static/ro_unit_b.d4c63ae0053cdbea6e2bb01b6e438511.png";